import { useState } from 'react';
import { instanceToPlain, plainToInstance } from 'class-transformer';
import { useNavigate, useParams } from 'react-router-dom';
// project import
import StandardForm from 'components/shared/StandardForm';
import FormStepper from 'components/form-stepper/FormStepper';
import { useEdit } from 'hooks/useEdit';
import { ActionCloseReason } from 'constants/CloseReasonTypes';
import { TypeMode } from 'constants/TypeMode';
import MainCard from 'components/MainCard';
import FullScreenDialog from 'components/modal/Modal';

// eslint-disable-next-line react/prop-types, no-unused-vars
const SurveyResultForm = ({
    navigateTo,
    slice,
    service,
    pageTitle,
    config,
    entity,
}) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(true);
    const defaultValue = {
        original_message:
            '09.10.2024 at 09:50 the aerial reconnaissance group 1 MIB 987 Mech. Inf. Bde detected 2 military personnel on the territory of the RF near the north-west outskirts of the settlement XXXXXXXXXX moving towards DKU into wooded area. Distance from DK up to 200 m. Coordinates: MGRS: 36U YA 06376 91531. Fire damage is being inflicted by mortar, AGS and FPV. Broadcast: 1 MIB 987 Mech. Inf. Bde, stream "Kuzya".',
        id: 20,
        external_id: 'c775191b-fe60-41a4-baaa-2c6e97046775',
        source: 'whatsapp',
        type: 'OBSERVATION',
        started_at: '09.10.2024 09:50',
        finished_at: null,
        created_at: '2024-10-24T21:20:05.280566',
        updated_at: '2024-10-24T21:20:05.280567',
        unit: '1 MIB 987 Mech. Inf. Bde',
        local_unit: null,
        weapon_type: null,
        mgrs_coordinates: ['36U YA 06376 91531'],
        coordinates: [[50.43946163646473, 35.90646058806631]],
        direction: 'to DKU',
        azimuth: null,
        target_type: 'personnel',
        target_quantity: 2,
        result: 'Fire damage is being inflicted by mortar',
        status: false,
        link: 'https://xsltdev.ru/favicon.ico',
    };
    const status = 'success';

    const handleOnClose = action => {
        setOpen(false);
        navigate(navigateTo, {
            state: action === ActionCloseReason.Submit ? 'refresh' : null,
        });
    };

    return (
        <FullScreenDialog
            open={open}
            title={pageTitle}
            onClose={() => handleOnClose(ActionCloseReason.Close)}
        ></FullScreenDialog>
    );
};

export default SurveyResultForm;
